import { useEffect, useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    overflow: visible;
    z-index: 1;
    pointer-events: none;
    touch-action: pan-y;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        pointer-events: none;
    }

    .progressive-banner__placeholder {
        position: absolute;
        inset: 0;
        filter: blur(8px);
        transform: scale(1.03);
        image-rendering: auto;

        @media (max-width: 1000px) {
            filter: blur(6px);
            transform: scale(1.02);
        }
    }

    .progressive-banner__hd {
        position: absolute;
        inset: 0;
        opacity: 0;
        transition: opacity 250ms ease;
    }

    .progressive-banner__hd.is-loaded {
        opacity: 1;
    }
`;

type ProgressiveBannerProps = {
    hdSrc: string;
    placeholderSrc: string;
    className?: string;
    alt?: string;
};

export const ProgressiveBanner = ({
    hdSrc,
    placeholderSrc,
    className,
    alt = "",
}: ProgressiveBannerProps) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(false);
        const img = new Image();
        img.src = hdSrc;
        if (img.complete) {
            setLoaded(true);
            return;
        }
        img.onload = () => setLoaded(true);
        img.onerror = () => setLoaded(true);
    }, [hdSrc]);

    return (
        <Wrapper className={className}>
            <img
                src={placeholderSrc}
                alt=""
                className="progressive-banner__placeholder"
                aria-hidden
            />
            <img
                src={hdSrc}
                alt={alt}
                className={`progressive-banner__hd${loaded ? " is-loaded" : ""}`}
                onLoad={() => setLoaded(true)}
            />
        </Wrapper>
    );
};
